/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'tools.ozone.hosting.getAccountHistory'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  did: /*#__PURE__*/ l.string({ format: 'did' }),
  events: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.string<{
        knownValues: [
          'accountCreated',
          'emailUpdated',
          'emailConfirmed',
          'passwordUpdated',
          'handleUpdated',
        ]
      }>(),
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ minimum: 1, maximum: 100 }),
      50,
    ),
  ),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  events: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<Event>((() => event) as any),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get account history, e.g. log of updated email addresses or other identity information. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

type Event = {
  $type?: 'tools.ozone.hosting.getAccountHistory#event'
  details:
    | l.$Typed<AccountCreated>
    | l.$Typed<EmailUpdated>
    | l.$Typed<EmailConfirmed>
    | l.$Typed<PasswordUpdated>
    | l.$Typed<HandleUpdated>
    | l.Unknown$TypedObject
  createdBy: string
  createdAt: l.DatetimeString
}

export type { Event }

const event = /*#__PURE__*/ l.typedObject<Event>(
  $nsid,
  'event',
  /*#__PURE__*/ l.object({
    details: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<AccountCreated>((() => accountCreated) as any),
        /*#__PURE__*/ l.typedRef<EmailUpdated>((() => emailUpdated) as any),
        /*#__PURE__*/ l.typedRef<EmailConfirmed>((() => emailConfirmed) as any),
        /*#__PURE__*/ l.typedRef<PasswordUpdated>(
          (() => passwordUpdated) as any,
        ),
        /*#__PURE__*/ l.typedRef<HandleUpdated>((() => handleUpdated) as any),
      ],
      false,
    ),
    createdBy: /*#__PURE__*/ l.string(),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { event }

type AccountCreated = {
  $type?: 'tools.ozone.hosting.getAccountHistory#accountCreated'
  email?: string
  handle?: l.HandleString
}

export type { AccountCreated }

const accountCreated = /*#__PURE__*/ l.typedObject<AccountCreated>(
  $nsid,
  'accountCreated',
  /*#__PURE__*/ l.object({
    email: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    handle: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'handle' }),
    ),
  }),
)

export { accountCreated }

type EmailUpdated = {
  $type?: 'tools.ozone.hosting.getAccountHistory#emailUpdated'
  email: string
}

export type { EmailUpdated }

const emailUpdated = /*#__PURE__*/ l.typedObject<EmailUpdated>(
  $nsid,
  'emailUpdated',
  /*#__PURE__*/ l.object({ email: /*#__PURE__*/ l.string() }),
)

export { emailUpdated }

type EmailConfirmed = {
  $type?: 'tools.ozone.hosting.getAccountHistory#emailConfirmed'
  email: string
}

export type { EmailConfirmed }

const emailConfirmed = /*#__PURE__*/ l.typedObject<EmailConfirmed>(
  $nsid,
  'emailConfirmed',
  /*#__PURE__*/ l.object({ email: /*#__PURE__*/ l.string() }),
)

export { emailConfirmed }

type PasswordUpdated = {
  $type?: 'tools.ozone.hosting.getAccountHistory#passwordUpdated'
}

export type { PasswordUpdated }

const passwordUpdated = /*#__PURE__*/ l.typedObject<PasswordUpdated>(
  $nsid,
  'passwordUpdated',
  /*#__PURE__*/ l.object({}),
)

export { passwordUpdated }

type HandleUpdated = {
  $type?: 'tools.ozone.hosting.getAccountHistory#handleUpdated'
  handle: l.HandleString
}

export type { HandleUpdated }

const handleUpdated = /*#__PURE__*/ l.typedObject<HandleUpdated>(
  $nsid,
  'handleUpdated',
  /*#__PURE__*/ l.object({
    handle: /*#__PURE__*/ l.string({ format: 'handle' }),
  }),
)

export { handleUpdated }
